import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';

const DropdownValue = ({ rule, onValueChange, disabled }) => (
  <Dropdown
    selection
    options={rule.valueOptions}
    value={rule.selectedValue}
    onChange={(e, data) => onValueChange(rule.id, 'selectedValue', data.value)}
    disabled={disabled}
  />
);

DropdownValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default DropdownValue;
